import {EuiFlexGroup, EuiFlexItem} from "@elastic/eui";
import {ProductGroupCard} from "../../components/products/ProductGroupCard";
import {useGetProductGroupsQuery} from "../../api/rtkQueryApi/ProductsApi";
import {useEffect, useState} from "react";
import {ProductGroup} from "../../api/entities/ProductGroup";
import {Product} from "../../api/entities/Product";

export interface IProductSelector {
    selectedProductId?: string;
    onProductSelected?: (product: Product, productGroup?: ProductGroup) => void;
    center?: boolean;
    onProductGroupClicked?: (productGroup: ProductGroup) => void;
    showAllProducts: boolean;
}

export const ProductSelector: React.FC<IProductSelector> = (props) => {
    const getProductGroupsQuery = useGetProductGroupsQuery();
    const [productGroups, setProductGroups] = useState<ProductGroup[]>([]);

    const [filteredProductGroups, setFilteredProductGroups] = useState<ProductGroup[]>([]);

    useEffect(() => {
        if (getProductGroupsQuery.data) {
            setProductGroups(getProductGroupsQuery.data);
        }
    }, [getProductGroupsQuery.data]);

    useEffect(() => {
        let filteredGroups = productGroups.filter((group) => props.showAllProducts || group.isFlagshipProgram);
        filteredGroups = filteredGroups.sort((a, b) => b.pricePerMonth - a.pricePerMonth);
        const dsIndex = filteredGroups.findIndex((group) => group.name === "Dragon Slayer");
        if (dsIndex !== -1) {
            const ds = filteredGroups.splice(dsIndex, 1)[0];
            filteredGroups.push(ds);
        }

        setFilteredProductGroups(filteredGroups);
    }, [productGroups, props.showAllProducts]);

    const onProductSelected = (product: Product) => {
        const productGroup = productGroups.find((group) =>
            group.products.find((p) => p.id === product.id),
        );
        props.onProductSelected?.(product, productGroup);
    };

    return (
        <EuiFlexGroup
            wrap
            justifyContent={props.center ? "center" : undefined}
            alignItems={props.center ? "center" : undefined}
        >
            {filteredProductGroups
                .map((group) => {
                    return (
                        <EuiFlexItem grow={false} style={{alignSelf: "stretch"}}>
                            <ProductGroupCard
                                productGroup={group}
                                onProductSelected={onProductSelected}
                                selectedProductId={props.selectedProductId}
                                onProductGroupClicked={props.onProductGroupClicked}
                            />
                        </EuiFlexItem>
                    );
                })}
        </EuiFlexGroup>
    );
};
